// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"AccountPageSettingList--next-sr-only--2sk21vY","dialog":"AccountPageSettingList--dialog--2A2m0Un","submitBtnBox":"AccountPageSettingList--submitBtnBox--1FOdNLF"};